module.exports = __webpack_public_path__ + "img/wenhua (4).915120a1.png";